import { QRCodeSVG } from '@cheprasov/qrcode';

export default class AppDownload {
  constructor(element, currentUser) {
    this.element = element;
    this.currentUser = currentUser;
  }

  type() {
    return 'app_download';
  }

  show() {
    this.generateQrCode();

    if(this.currentUser) {
      const loginSubtitle = this.element.querySelector('.content-gating-banner__subtitle--login');
      if(loginSubtitle) {
        loginSubtitle.classList.remove('hide');
      }
    } else {
      const nonLoginSubtitle = this.element.querySelector('.content-gating-banner__subtitle--non-login');
      if(nonLoginSubtitle) {
        nonLoginSubtitle.classList.remove('hide');
      }
    }

    this.element.classList.remove('hide');
  }

  generateQrCode() {
    const qrCode = this.element.querySelector('.content-gating-banner__qr-image');
    if(qrCode) {
      const deepLinkUrl = qrCode.getAttribute('data-deep-link');
      const centerLogoUrl = qrCode.getAttribute('data-logo');

      let imageOption = null;
      if (centerLogoUrl) {
        imageOption = {
          image: {
            source: centerLogoUrl,
            width: '20%',
            height: '20%',
            x: 'center',
            y: 'center',
          }
        };
      }

      const qrSVG = new QRCodeSVG(deepLinkUrl, imageOption);
      const xmlWithQRCode = qrSVG.toString();

      qrCode.innerHTML = xmlWithQRCode;
    }
  }
}